import type { ComponentProps, FC } from "react";
import { Box, IconButton, Stack, Toolbar } from "@mui/material";
import { AccountMenu } from "../AccountMenu/AccountMenu";
import { Icon } from "../../atoms/Icon/Icon";
import { KikVLogo } from "../../atoms/kik-v-logo";
import { AppBar as StyledAppbar, Logo } from "./AppBar.styles";
import { useNavigate } from "@tanstack/react-router";

export const AppBar: FC<{
    iconButton?: ComponentProps<typeof IconButton>;
    accountMenu?: ComponentProps<typeof AccountMenu>;
}> = ({ iconButton, accountMenu }) => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate({ to: "/" });
    };

    return (
        <StyledAppbar position="fixed">
            <Toolbar>
                <Stack direction={"row"} gap={2}>
                    <Box
                        sx={{
                            display: { xs: "grid", sm: "none" },
                            placeItems: "center",
                            pl: 2,
                        }}
                    >
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={iconButton?.onClick}
                            sx={{ p: 0 }}
                        >
                            <Icon name="menu" />
                        </IconButton>
                    </Box>
                    <Logo onClick={handleLogoClick} sx={{ cursor: "pointer" }}>
                        <KikVLogo width={40} height={40} title="KIK-V Logo" />
                    </Logo>
                </Stack>
                <Box sx={{ flexGrow: 1 }} />
                {accountMenu ? <AccountMenu {...accountMenu} /> : null}
            </Toolbar>
        </StyledAppbar>
    );
};
